export const emailregex: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const passwordRegex: RegExp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_])[A-Za-z\d\W_]{8,20}$/; 
export const faxnumberregex: RegExp = /[\+? *[1-9]+]?[0-9 ]+/;
export const PhoneNumberValidatorRegex = '(d{3})sd{3}-d{4}';
export const expiredSessionErrorMessage = 'Your session has expired. please login again.'
export const passwordValidationMessage = 'Password must be 8 to 20 characters long and include at least one uppercase letter, one lowercase letter, one number, and one special character.';
export const oldPasswordMatchValidationMessage = 'Your new password must be different from your previous password.';
export const confirmPasswordMatchValidationMessage = 'New password & confirm password does not match.';
export const login_Validation_Message = {
  email: [
    { type: 'required', message: 'Required' },
    { type: 'pattern', message: 'Invalid email' },
  ],
  Passwors: [{ type: 'required', message: 'Required' }],
};
export const listingBodyParameter = {
  stSearchText: '',
  stSortColumn: '',
  stSortOrder: 'desc',
  inOffset: 0,
  inLimit: 25,
};

export const listingBodyParameterForRoleHistory = {
  stSearchText: '',
  stSortColumn: '',
  stSortOrder: 'desc',
  inOffset: 0,
  inLimit: 25,
};

export const listingBodyParameterTeamHistory = {
 stSearchText: '',
 stSortColumn: '',
  stSortOrder: 'desc',
  inOffset: 0,
  inLimit: 25,
};

export const listingBodyParameterForSuperAdminProduct = {
  stSearchText: '',
  stSortColumn: '',
  stSortOrder: 'desc',
  inOffset: 0,
  inLimit: 25,
};

export const listingBodyParameterForFeedback = {
  stSearchText: '',
  stSortColumn: '',
  stSortOrder: 'desc',
  inOffset: 0,
  inLimit: 25,
};

export const listingBodyParameterForClientHistory = {
  stSearchText: '',
  stSortColumn: '',
  stSortOrder: 'desc',
  inOffset: 0,
  inLimit: 25,
};

export const listingBodyParameterForPaymentProfile = {
  stSearchText: '',
  stSortColumn: '',
  stSortOrder: 'desc',
  inOffset: 0,
  inLimit: 25,
};

export const listingBodyParameterForUser = {
  stSearchText: '',
  stSortColumn: '',
  stSortOrder: 'desc',
  inOffset: 0,
  inLimit: 25,
};

export const listingBodyParameterForTeam = {
  stSearchText: '',
  stSortColumn: 'stName',
  stSortOrder: 'desc',
  inOffset: 0,
  inLimit: 25,
};
export const listingBodyParameterForRole = {
  stSearchText: '',
  stSortColumn: '',
  stSortOrder: 'desc',
  inOffset: 0,
  inLimit: 25,
};

export const listingBodyParameterForClientproduct = {
  stSearchText: '',
  stSortColumn: '',
  stSortOrder: 'desc',
  inOffset: 0,
  inLimit: 25,
};

export const listingBodyParameterForCensus = {
  stSearchText: '',
  stSortColumn: '',
  stSortOrder: 'desc',
  inOffset: 0,
  inLimit: 25,
};

export const listingBodyParameterClients = {
  stSearchText: '',
  stSortColumn: '',
  stSortOrder: 'asc',
  inOffset: 0,
  inLimit: 25,
};

export const listingBodyParameterClaimMonitor = {
  stSortColumn: '',
  stSortOrder: 'desc',
  stSearch: '',
  offset: 0,
  limit: 25,
  dtFromDate: null,
  dtToDate: null,
  uiLogBy : null
};

export const listingBodyParameterClaimPreview= {
  stSortColumn: '',
  stSortOrder: 'desc',
  stSearch: '',
  offset: 0,
  limit: 25,
  dtFromDate: null,
  dtToDate: null,
  uiLogBy : null,
  priorityId:null
};

export const listingBodyParameterForReportReviewer = {
  stSearchText: '',
  stSortColumn: '',
  stSortOrder: 'desc',
  inOffset: 0,
  inLimit: 25,
};

export const listingBodyParameterMediaForensics = {
  stSortColumn: '',
  stSortOrder: 'desc',
  stSearch: '',
  inOffset: 0,
  inLimit: 25,
  dtFromDate: null,
  dtToDate: null,
  uiLogBy : null
};

export const perPageArray = [
  { val: 25, text: '25' },
  { val: 100, text: '100' },
  { val: 500, text: '500' },
  { val: 1000, text: '1000' },
  { val: 5000, text: '5000' },
];

export const selected2FAMethod: any = {
  data: ''
};

export const investigatorUser: any = {
  isTeamViewEnable: null
}